import { IndexaContributionYearsResponse } from './types';

export default async function getIndexaContributionYears(
	token: string
): Promise<IndexaContributionYearsResponse> {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/thirdparty/indexa/contributions/years`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error(`Network response was not ok: ${response.status}`);
	}

	const result: IndexaContributionYearsResponse = await response.json();
	return result;
}
